import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ChatDialogComponent } from '@app/dialogs/chat-dialog/chat-dialog.component';
import { YesNoDialogComponent } from '@app/dialogs/yes-no-dialog/yes-no-dialog.component';
import { DocumentReadModes } from '@app/enums/DocumentReadModes';
import ChatVisibilityHelper from '@app/helpers/ChatvisibilityHelper';
import LocalStorage from '@app/helpers/LocalStorage';
import SessionStorage from '@app/helpers/SessionStorage';
import { BottomBarService } from '@app/services/bottom-bar.service';
import { HeaderService } from '@app/services/header.service';
import { SessionstorageService } from '@app/services/sessionstorage.service';
import { ActiveHoursDialogComponent } from '@globalshared/chat/src/lib/dialog/active-hours/active-hours-dialog.component';
import { ChatService } from '@globalshared/chat/src/lib/services/chat.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-age-selection',
  templateUrl: './age-selection.component.html',
  styleUrls: ['./age-selection.component.scss']
})
export class AgeSelectionComponent implements OnInit {

  queryParams: Params;
  editorForm: FormGroup;

  messageCounterAfterClose: number = 0
  messageCounter: number = 0
  badgeValue: number = 0

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private bottomBarService: BottomBarService,
    private headerService: HeaderService,
    public sessionStorageService: SessionstorageService,
    private translate: TranslateService,
    private chatService: ChatService,
    private dialog: MatDialog

  ) {

    this.editorForm = this.fb.group({
      selectedAge: new FormControl('o14')
    })
  }

  ngOnInit() {

    this.chatService.customerFacingDataLength.subscribe(data => {
      this.messageCounter = data;

      if (this.messageCounter > this.messageCounterAfterClose) {
        this.badgeValue = this.messageCounter - this.messageCounterAfterClose
      } else {
        this.badgeValue = 0
      }
    })

    this.bottomBarService.setBottomBarVisibility(true);
    this.headerService.setNavigationVisibility(true);
    this.activatedRoute.queryParams.subscribe(params => {
      this.queryParams = params;
    })
  }

  openChat() {
    if (this.chatService.isWithin()) {
      let reOpenChat = localStorage.getItem('reOpenChat');
      if (reOpenChat === 'true') {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: true
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
      } else {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: false
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
        // this.dialog.open(YesNoDialogComponent, {
        //   disableClose: true,
        //   hasBackdrop: true,
        //   width: "auto",
        //   data: { messageText: this.translate.instant('chat.start_chat_question'), messageType: 'CHAT', showIcon: true }
        // }).afterClosed().subscribe(data => {
        //   if (data) {
        //     this.dialog.open(ChatDialogComponent, {
        //       minWidth: '100vw',
        //       height: '100dvh',
        //       data: {
        //         isMinimized: false
        //       }
        //     }).afterClosed().subscribe(data => {
        //       this.badgeValue = 0
        //       this.messageCounterAfterClose = data
        //     })
        //   }
        // })
      }
    } else {
      this.dialog.open(ActiveHoursDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: "auto",
        data: { messageText: this.translate.instant('chat.non-active-session-title'), messageType: 'WARNING', showIcon: true }
      })
    }
  }

  forwardClick() {
    if (this.editorForm.controls["selectedAge"].value == "o14") {
      SessionStorage.GuestAge = 'o14';
      if (LocalStorage.IsTabletMode) {
        if (LocalStorage.OperationMode == "VIP") {
          if (SessionStorage.PhotoInTabletMode == DocumentReadModes.DOCUMENT_READ_AND_SELFIE || SessionStorage.PhotoInTabletMode == DocumentReadModes.DOCUMENT_READ_ONLY) {
            this.router.navigateByUrl('/photo')
          } else {
            this.router.navigateByUrl('/vizadata')
          }
        } else {
          if (SessionStorage.PhotoInTabletApp == DocumentReadModes.DOCUMENT_READ_AND_SELFIE || SessionStorage.PhotoInTabletApp == DocumentReadModes.DOCUMENT_READ_ONLY) {
            this.router.navigateByUrl('/photo')
          } else {
            this.router.navigateByUrl('/vizadata')
          }
        }
      } else {
        if (SessionStorage.PhotoInExi == DocumentReadModes.DOCUMENT_READ_AND_SELFIE || SessionStorage.PhotoInExi == DocumentReadModes.DOCUMENT_READ_ONLY) {
          this.router.navigateByUrl('/photo')
        } else { // nem kell fotó,mehet a vizadata-ra
          this.router.navigateByUrl('/mobilewarning')
        }
      }
    }
    else {
      SessionStorage.GuestAge = 'u14';
      this.router.navigate(["/vizadata"], { queryParams: this.queryParams })
    }
  }

  chatIconStyle() {
    let styles = {};
    styles = ChatVisibilityHelper.ChatVisibleStyle
    return styles
  }
}
